export default {
  title: "Autenticazione",
  login: {
    title: "Accedi",
    description: "Accedi al tuo account",
    form: {
      email: "E-mail",
      password: "Password",
      rememberMe: "Ricordami",
      submit: "Accedi",
      forgotPassword: "Password dimenticata?"
    },
    errors: {
      invalidCredentials: "Email o password non corretti",
      userNotFound: "Nessun account trovato con questa email",
      tooManyAttempts: "Troppi tentativi, riprova più tardi"
    }
  },
  logout: "Esci",
  register: {
    title: "Iscriviti",
    description: "Crea il tuo account",
    form: {
      firstName: "Nome",
      lastName: "Cognome",
      email: "E-mail",
      password: "Password",
      confirmPassword: "Conferma password",
      terms: "Accetto i termini di utilizzo",
      submit: "Registrati"
    },
    errors: {
      emailExists: "Esiste già un account con questa email",
      passwordTooWeak: "La password è troppo debole",
      passwordsDontMatch: "Le password non corrispondono",
      termsNotAccepted: "Devi accettare i termini di utilizzo"
    }
  },
  forgotPassword: {
    title: "Password dimenticata",
    description: "Resetta la tua password",
    form: {
      email: "E-mail",
      submit: "Invia link di ripristino"
    },
    success: "È stata inviata un'email di ripristino",
    errors: {
      userNotFound: "Nessun account trovato con questa email",
      tooManyAttempts: "Troppi tentativi, riprova più tardi"
    }
  },
  resetPassword: {
    title: "Reimposta password",
    description: "Scegli una nuova password",
    form: {
      password: "Nuova password",
      confirmPassword: "Conferma password",
      submit: "Reimposta password"
    },
    success: "La tua password è stata reimpostata",
    errors: {
      invalidToken: "Il link di ripristino non è valido o è scaduto",
      passwordTooWeak: "La password è troppo debole",
      passwordsDontMatch: "Le password non corrispondono"
    }
  },
  email: "Email",
  password: "Password",
  confirmPassword: "Conferma password",
  rememberMe: "Ricordami",
  loginButton: "Accedi",
  registerButton: "Registrati",
  loginWithGoogle: "Accedi con Google",
  loginWithFacebook: "Accedi con Facebook",
  registerWithGoogle: "Registrati con Google",
  registerWithFacebook: "Registrati con Facebook",
  or: "oppure",
  alreadyHaveAccount: "Hai già un account?",
  dontHaveAccount: "Non hai un account?",
  loginHere: "Accedi qui",
  registerHere: "Registrati qui",
  sendResetEmail: "Invia email di reset",
  backToLogin: "Torna al login",
  checkEmail: "Controlla la tua email",
  resetEmailSent: "Email di reset password inviata",
  invalidCredentials: "Credenziali non valide",
  emailRequired: "L'email è obbligatoria",
  passwordRequired: "La password è obbligatoria",
  emailInvalid: "Indirizzo email non valido",
  passwordTooShort: "La password deve essere di almeno 6 caratteri",
  passwordsMismatch: "Le password non corrispondono",
  loginSuccess: "Accesso riuscito",
  registrationSuccess: "Registrazione riuscita",
  logoutSuccess: "Disconnessione riuscita",
  error: "Errore di autenticazione",
  loginError: "Errore di accesso",
  registrationError: "Errore di registrazione",
  resetPasswordError: "Errore nel reset della password",
  socialLoginError: "Errore di accesso social",
  weakPassword: "La password è troppo debole",
  emailAlreadyExists: "L'email esiste già",
  userNotFound: "Utente non trovato",
  wrongPassword: "Password sbagliata",
  tooManyRequests: "Troppe richieste, riprova più tardi",
  networkError: "Errore di rete",
  emailVerificationRequired: "Verifica email richiesta",
  emailVerificationSent: "Email di verifica inviata",
  verifyEmail: {
    title: "Verifica email",
    description: "Verifica il tuo indirizzo email",
    success: "La tua email è stata verificata",
    resend: "Invia nuovamente l'email di verifica",
    errors: {
      invalidToken: "Il link di verifica non è valido o è scaduto",
      alreadyVerified: "Questa email è già stata verificata"
    }
  },
  resendVerification: "Reinvia verifica",
  emailVerified: "Email verificata con successo",
  verificationError: "Errore di verifica",
  continueWithEmail: "Continua con email",
  continueWithPassword: "Continua con password",
  terms: "Termini di servizio",
  privacy: "Politica sulla privacy",
  agreeToTerms: "Accetto i Termini di servizio e la Politica sulla privacy",
  termsRequired: "Devi accettare i termini e le condizioni",
  firstName: "Nome",
  lastName: "Cognome",
  fullName: "Nome completo",
  loading: "Caricamento...",
  pleaseWait: "Attendere prego...",
  welcome: "Benvenuto",
  welcomeBack: "Bentornato",
  loginWithApple: "Accedi con Apple",
  signupWithGoogle: "Registrati con Google",
  signupWithFacebook: "Registrati con Facebook",
  signupWithApple: "Registrati con Apple",
  loggingIn: "Accesso in corso...",
  continueWith: "o continua con",
  protectedBy: "Protetto da",
  termsNotice: "Continuando, accetti i nostri",
  termsOfService: "Termini di servizio",
  and: "e",
  privacyPolicy: "Politica sulla privacy",
  verifyPhone: "Verifica il tuo telefono",
  verifyPhoneMessage: "Inserisci il tuo numero di telefono per ricevere un codice di verifica via SMS",
  phoneNumber: "Numero di telefono",
  phoneNumberFormat: "Senza il primo zero per la Francia, es: 612345678",
  skipStep: "Salta questo passaggio per ora",
  verifySms: "Verifica il codice SMS",
  verifySmsMessage: "Abbiamo inviato un codice a 6 cifre al numero",
  resendCodeIn: "Reinvia codice tra",
  resendCode: "Reinvia codice",
  verifyEmailMessage: "Abbiamo inviato un codice a 6 cifre a",
  verifyingEmail: "Verifica email in corso...",
  tryAgain: "Riprova",
  redirecting: "Reindirizzamento...",
  noCodeReceived: "Non hai ricevuto un codice?",
  accessLevels: {
    view: "Solo visualizzazione",
    edit: "Modifica",
    manage: "Gestione completa"
  },
  accessInfo: {
    connectedAs: "Connesso come"
  },
  accessRestriction: {
    title: "Accesso limitato",
    insufficientLevel: "Livello di accesso insufficiente",
    login: "Accedi"
  },
  currentLevel: "Livello attuale",
  requiredLevel: "Livello richiesto",
  errors: {
    default: "Si è verificato un errore",
    suspiciousActivity: "Attività sospetta rilevata. Riprova.",
    recaptchaFailed: "Verifica di sicurezza fallita. Riprova.",
    recaptchaUnavailable: "Il servizio di sicurezza è temporaneamente non disponibile. Riprova più tardi.",
    recaptchaTimeout: "La verifica di sicurezza ha richiesto troppo tempo. Controlla la tua connessione e riprova.",
    accountExistsWithDifferentCredential: "Esiste già un account con credenziali diverse",
    popupClosed: "La finestra di login è stata chiusa",
    disallowedUserAgent: "User agent non consentito",
    socialLoginFailed: "Login sociale fallito",
    invalidPhone: "Numero di telefono non valido",
    genericError: "Si è verificato un errore",
    invalidCode: "Codice non valido, inserisci le 6 cifre.",
    loginFailed: "Login fallito",
    googleLoginFailed: "Login Google fallito",
    facebookLoginFailed: "Login Facebook fallito",
    emailAlreadyInUse: "Questa email è già in uso",
    invalidEmail: "Email non valida",
    emailNotFound: "Email non trovata. Riprova il processo di registrazione.",
    verificationFailed: "Verifica fallita. Riprova.",
    invalidLink: "Link di verifica non valido.",
    pendingInvitation: "Errore nel verificare gli inviti in sospeso",
    accept: "Errore nell'accettare l'invito",
    decline: "Errore nel rifiutare l'invito",
    loadInvitation: "Errore nel caricare l'invito",
    accountExists: "Esiste già un account con questo indirizzo email, ma con un metodo di accesso diverso.",
    operationNotAllowed: "Questo metodo di accesso non è abilitato. Contatta il supporto.",
    emailInUse: "Questa email è già in uso",
    networkError: "Errore di rete",
    popupCancelled: "Operazione annullata",
    tooManyRequests: "Troppi tentativi, riprova più tardi",
    weakPassword: "La password è troppo debole",
    wrongPassword: "Password errata",
    userNotFound: "Utente non trovato"
  },
  webViewWarning: "Per accedere con Google, apri questa pagina in un browser standard come Safari, Chrome o Firefox.",
  signIn: "Accedi",
  createAccount: {
    submit: "Crea account",
    title: "Crea un account",
    description: "Crea un account per gestire il tuo matrimonio",
    benefits: "Vantaggi della creazione di un account"
  },
  signInWithGoogle: "Accedi con Google",
  continueAsGuest: "Continua come ospite",
  oauth: {
    google: "Continua con Google",
    facebook: "Continua con Facebook",
    apple: "Continua con Apple"
  },
  messages: {
    loggedIn: "Accesso effettuato con successo",
    loggedOut: "Disconnesso con successo",
    registered: "Account creato con successo",
    emailVerified: "Email verificata con successo",
    passwordReset: "Password reimpostata con successo"
  },
  facebook: {
    accountExists: {
      description: "Esiste già un account con questa email associato a un altro metodo di accesso.",
      step1: "Accedi con il tuo metodo abituale",
      step2: "Collega il tuo account Facebook nelle impostazioni",
      title: "Account esistente"
    },
    general: {
      privacy: "Privacy",
      privacyText: "Non pubblicheremo mai nulla sulla tua bacheca senza il tuo permesso.",
      tip1: "Assicurati che i popup siano consentiti",
      tip2: "Verifica di essere connesso a Facebook",
      tip3: "Consenti l'accesso alla tua email",
      tip4: "Se l'errore persiste, prova con un altro browser",
      tip5: "O usa email e password",
      title: "Accedi con Facebook"
    },
    popupBlocked: {
      description: "Il browser ha bloccato la finestra di accesso a Facebook.",
      note: "Nota",
      noteText: "Se il problema persiste, prova a disabilitare temporaneamente il blocco annunci.",
      step1: "Cerca l'icona di blocco nella barra degli indirizzi",
      step2: "Clicca su di esso e consenti i popup per questo sito",
      step3: "Riprova ad accedere",
      title: "Popup bloccato"
    },
    unauthorizedDomain: {
      title: "Dominio non autorizzato",
      description: "Questo dominio non è autorizzato per l'autenticazione Facebook.",
      note: "Nota",
      noteText: "Si prega di contattare l'amministratore."
    },
    understood: "Ho capito"
  }
};
